export class LoadingLayer {
  text: string;
  verifier: () => boolean;

  constructor(text: string, verifier: () => boolean) {
    this.text = text;
    this.verifier = verifier;
  }
}
